import { H2 } from "@/lib/styles";
import {
  bigLabelTypographicStyle,
  smallLabelTypographicStyle,
} from "@/lib/styles/helpers";
import styled from "styled-components";

export const ContactsContainer = styled.div`
  * {
    box-sizing: border-box;
  }
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.mediaQueries.tablet} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const Heading = styled(H2)`
  width: 100%;
  ${({ theme }) => theme.mediaQueries.tablet} {
    padding: 0 1.5rem;
  }
`;

export const Subheading = styled.p`
  ${bigLabelTypographicStyle}

  color: ${({ theme }) => theme.colors.darkMiddle};
`;
export const Info = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({theme})=> theme.colors.white};
  gap: 16px;
  ${({ theme }) => theme.mediaQueries.tablet} {
    padding: 0 1.5rem;
  }
  ${({ theme }) => theme.mediaQueries.laptop} {
    gap: 18px;
  }
`;

export const ContactBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;

  ${({ theme }) => theme.mediaQueries.desktop} {
    flex-direction: row;
    gap: 4px;
  }
`;

export const Label = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;
export const IconWrapper = styled.div`
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  padding-bottom: 2px;
`;

export const LabelText = styled.p`
  ${smallLabelTypographicStyle}
  color: ${({ theme }) => theme.colors.darkMiddle};
  text-transform: uppercase;
`;

export const Address = styled.div`
  ${smallLabelTypographicStyle}
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black};
`;
export const Email = styled.div`
  ${smallLabelTypographicStyle}
  font-weight: 400;
  color: ${({ theme }) => theme.colors.red};
`;
export const Phone = styled.div`
  ${smallLabelTypographicStyle}
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black};
`;
